import React from 'react';
import {useEffect} from "react"
import NeshanMap from "@neshan-maps-platform/react-openlayers"

import Header from "../../Layouts/Header";
import {MdVerified} from "react-icons/md";
import {TbBrandGoogleMaps} from "react-icons/tb";
import {Map} from "@neshan-maps-platform/ol"
 import { fromLonLat } from '@neshan-maps-platform/ol/proj';
// import layer from '@neshan-maps-platform/ol'
import "@neshan-maps-platform/react-openlayers/dist/style.css"
import Feature from '@neshan-maps-platform/ol/Feature.js';
import Point from '@neshan-maps-platform/ol/geom/Point.js';
import VectorSource from "@neshan-maps-platform/ol/source/Vector";
import VectorLayer from "@neshan-maps-platform/ol/layer/Vector";
const NewAddress = () => {

    const [address, setAddress] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [theMap, setTheMap] = React.useState(null);
    const [haveLocation, setHaveLocation] = React.useState(false);

    const onInit = (map: Map) => {
        setTheMap(map)
        //console.log(map.getView().getCenter(), 'EPSG:21781', 'EPSG:4326')
      }


    useEffect(() => {
        if (theMap){
          //  console.log(theMap.getView().getCenter())
            const iconFeature = new Feature({
                geometry: new Point(fromLonLat([36.3058262, 59.53509])),
            });
            const vectorSource = new VectorSource({
                features: [iconFeature],
            });
            const vectorLayer = new VectorLayer({
                source: vectorSource,
            });
            theMap.addLayer(vectorLayer);
        }



    }, [theMap])


    theMap?.on("moveend", function(e){
        console.log(theMap.getView().getCenter())
        const iconFeature = new Feature({
            geometry: new Point(fromLonLat([36.3058262, 59.53509])),
            name: 'Null Island',
            population: 4000,
            rainfall: 500,
        });
        const vectorSource = new VectorSource({
            features: [iconFeature],
        });
        const vectorLayer = new VectorLayer({
            source: vectorSource,
        });
        theMap.addLayer(vectorLayer);
    });

    return (
        <React.Fragment>
            <Header title='افزودن آدرس جدید' hasBack={true} />
            {
                haveLocation &&
                <section className="container-fluid modal-bg max-w-lg p-0">
                    <div className="row rtl overflow-scroll vh-100 mb-5p-0">

                        <div className="col-12 text-center p-0">
                            <div className='verify-map-button '>
                                <button className='w-100 btn btn-warning fw-bold text-small-2 p-3  '
                                        onClick={() => setHaveLocation(false)}
                                >
                                    <MdVerified className='mx-2 text-big-3' />
                                    تایید موقعیت مکانی
                                </button>
                            </div>
                            <div className='w-100 vh-100'>
                                <NeshanMap
                                    mapKey="web.1223f2b2e4914046b144c5449f54103e"
                                    zoom={13}
                                    style={{height: "100vh", width: "100%"}}
                                    traffic={false}
                                    poi={true}
                                    onInit={onInit}
                                     center={{latitude: 36.3058262, longitude: 59.5350915}}
                                ></NeshanMap>
                            </div>

                        </div>
                    </div>
                </section>
            }


            <section className="container-fluid  max-w-lg mt-5 pt-5">
                <div className="row rtl my-5">


                    <div className="col-12 form-floating mt-3">
                                                <textarea className="form-control"
                                                          placeholder="توضیحات"
                                                          style={{height: '120px'}}
                                                          id="floatingTextarea"
                                                          rows={20}
                                                          value={address}
                                                          onChange={(val) => {
                                                              setAddress(val.target.value)
                                                          }}
                                                >
                            </textarea>
                        <label htmlFor="floatingTextarea" className='text-small-2 pe-3'>

                            آدرس دقیق
                        </label>
                    </div>
                    <div className="col-12 my-3">
                       <div className='alert alert-secondary p-3 text-small-2 fw-bold text-justify'>
                           برای سهولت کارشناسان ما در هنگام مراجعه به محل شما بهتر است  محل آدرس خود بر روی نقشه را هم مشخص کنید.
                           <div className='text-start'>
                               <button className=' btn btn-warning text-small-1 fw-bold px-5 mt-3'
                                     onClick={() => setHaveLocation(true)}

                               >
                                   <TbBrandGoogleMaps className='ms-2 text-big-3' />
                                  تعیین آدرس روی نقشه
                               </button>
                           </div>
                       </div>

                    </div>
                    <div className="col-12 mt-1">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control"
                                   id="floatingInput"
                                   placeholder="عنوان"
                                   value={title}
                                   onChange={(val) => {
                                       setTitle(val.target.value)
                                   }}
                            />
                            <label htmlFor="floatingInput" className='text-small-2'>عنوان آدرس (به عنوان مثال: خانه، شرکت و ...) </label>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control"
                                   id="floatingInput"
                                   placeholder="تماس"
                                   value={phone}
                                   onChange={(val) => {
                                       setPhone(val.target.value)
                                   }}
                            />
                            <label htmlFor="floatingInput" className='text-small-2'>شماره تماس (جهت هماهنگی) </label>
                        </div>
                    </div>
                    <div className="col-12 my-3">
                        <button className='w-100 btn btn-success text-small-2 p-3'
                             //   onClick={onSaveAddress}
                        >
                            ثبت آدرس
                        </button>
                    </div>
                    <div className="col-4 my-3">

                    </div>
                </div>
            </section>
        </React.Fragment>

    );


};

export default NewAddress;